import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, TransitionablePortal } from "semantic-ui-react";
import { closeModal } from "./modalReducer";
// import { useSwipeable } from "react-swipeable";

export default function ModalWrapper({
  children,
  size,
  header,
  modalTopButton,
  onUnmountAction,
  modalClassName,
  contentClassName,
  isClose = true,
  padding = "0 0 0 0",
  showAnimation = "fade up",
  hideAnimation = "fade up",
  showDuration = 300,
  hideDuration = 100,
  useMobileDurations = true,
  ...props
}) {
  const dispatch = useDispatch();

  const { responsive } = useSelector((state) => state.app);

  const [showTransition, setShowTransition] = useState(true);

  const openDuration =
    useMobileDurations && responsive.isMobile ? 300 : showDuration;
  const closeDuration =
    useMobileDurations && responsive.isMobile ? 200 : hideDuration;

  function handleCloseModal(e) {
    if (e) {
      e.stopPropagation();
    }
    setShowTransition(false);
    setTimeout(() => dispatch(closeModal()), closeDuration);
  }

  // const handlers = useSwipeable({
  //   onSwipedDown: () => handleCloseModal(),
  //   delta: 200,
  //   preventDefaultTouchmoveEvent: true,
  //   trackMouse: true,
  // });
  // in div under modal content:
  //             {...handlers}

  return (
    <TransitionablePortal
      open={showTransition}
      transition={{
        animation: showTransition ? showAnimation : hideAnimation,
        duration: { show: openDuration, hide: closeDuration },
      }}
    >
      <Modal
        className={modalClassName}
        open={true}
        onClose={() => handleCloseModal()}
        onUnmount={onUnmountAction}
        size={size}
        closeIcon={isClose}
        {...props}
      >
        {header && (
          <Modal.Header style={{ marginLeft: "6px" }}>{header}</Modal.Header>
        )}
        <Modal.Content
          className={contentClassName}
          style={{ position: "relative", padding: padding }}
          onClick={(e) => e.stopPropagation()}
        >
          {modalTopButton && (
            <div
              className="clickable"
              style={{ position: "absolute", right: 54, top: 10, zIndex: 15 }}
            >
              {modalTopButton}
            </div>
          )}
          {children}
        </Modal.Content>
      </Modal>
    </TransitionablePortal>
  );
}
